module.exports = __webpack_public_path__ + "img/detail_car_status.8160ee48.svg";